import { SAGA_ACTIONS } from "../../../_config";
import { useApiCall } from "../appApiCallHook";
import { apiCaller } from "../functions";

export function useCustomersApi() {
    const callApi = useApiCall();

    return {
        listCustomer: apiCaller(callApi, SAGA_ACTIONS.CUSTOMERS.LIST_CUSTOMER),
        searchCustomer: apiCaller(callApi, SAGA_ACTIONS.CUSTOMERS.SEARCH_CUSTOMER),
        addUpdateCustomer: apiCaller(callApi, SAGA_ACTIONS.CUSTOMERS.ADD_UPDATE_CUSTOMER),
        deleteCustomer: apiCaller(callApi, SAGA_ACTIONS.CUSTOMERS.DELETE_CUSTOMER),
        customerDetails: apiCaller(callApi, SAGA_ACTIONS.CUSTOMERS.CUSTOMER_DETAILS),
        importCustomers: apiCaller(callApi, SAGA_ACTIONS.CUSTOMERS.IMPORT_CUSTOMERS),
        listCustomerGroups: apiCaller(callApi, SAGA_ACTIONS.CUSTOMERS.LIST_CUSTOMER_GROUPS),
        deleteCustomerGroup: apiCaller(callApi, SAGA_ACTIONS.CUSTOMERS.DELETE_CUSTOMER_GROUP),
        addUpdateCustomerGroup: apiCaller(callApi, SAGA_ACTIONS.CUSTOMERS.ADD_UPDATE_CUSTOMER_GROUP),
        customerGroupRuleMaster: apiCaller(callApi, SAGA_ACTIONS.CUSTOMERS.CUSTOMER_GROUP_RULE_MASTER),
        searchCustomerGroups: apiCaller(callApi, SAGA_ACTIONS.CUSTOMERS.SEARCH_CUSTOMER_GROUPS),
        addUpdateCustomerGroupCustom: apiCaller(callApi, SAGA_ACTIONS.CUSTOMERS.ADD_UPDATE_CUSTOMER_GROUP_CUSTOM),
        getCustomerPromotions: apiCaller(callApi, SAGA_ACTIONS.CUSTOMERS.GET_CUSTOMER_PROMOTIONS),
    };
}
